import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import BlockSectionLoader from '../Loader/BlockSectionLoader';
import BalanceTransactionsTable from '../Portfolio/BalanceTransactions/BalanceTransactionsTable';
import LoadMore from '../LoadMore/LoadMore';

const FinancialBalanceTransactions = ({
  transactionsLoading,
  account,
  handleLoadMore,
  transactionsTotalCount,
  transactionList,
  pageNumber,
  pageSize,
  hasMore,
}) => {
  const element = document.getElementById('scrollTo')?.offsetTop;

  return (
    <div id="scrollTo">
      <BalanceTransactionsTable
        data={transactionList}
        accountUid={account.AccountUid}
        shouldShowTransactions={
          !isEmpty(transactionList) && !!transactionList.length
        }
      />
      <BlockSectionLoader noShadow isLoading={transactionsLoading} />
      {transactionsTotalCount > 0 && (
        <LoadMore
          // transactionsTotalCount alone isn't reliable (80431) — it can
          // still say "more available" after the Financial-filtered results
          // actually run out. hasMore (from useTransactionPagination) is the
          // backend-agnostic fallback: it goes false once a page comes back
          // shorter than pageSize (including empty), so the button disables
          // exactly when the real end is reached, not one click later. Also
          // disabled while a page is loading — a second
          // click fired before the first resolves would cancel it outright
          // (ACCOUNT_TRANSACTIONS_FETCH is takeLatest), silently skipping
          // that page's rows for the rest of the session. The click handler
          // itself (handleLoadMore) also guards this synchronously via a
          // ref, since this disabled attribute can't update until after a
          // render.
          loadMoreDisabled={
            pageNumber * pageSize >= transactionsTotalCount ||
            !hasMore ||
            transactionsLoading
          }
          onLoadClick={handleLoadMore}
          scrollToElement={element}
        />
      )}
    </div>
  );
};

FinancialBalanceTransactions.propTypes = {
  transactionList: PropTypes.arrayOf(PropTypes.shape({})),
  transactionsLoading: PropTypes.bool,
  account: PropTypes.shape({
    AccountUid: PropTypes.string,
  }),
  handleLoadMore: PropTypes.func,
  transactionsTotalCount: PropTypes.number,
  pageNumber: PropTypes.number,
  pageSize: PropTypes.number,
  hasMore: PropTypes.bool,
};

export default FinancialBalanceTransactions;
